import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../../api/apiProfile";
import i18next from "i18next";

/**
 * Hook لجلب بيانات البروفايل
 */
export function useGetProfile() {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["profile", i18next.language],
        queryFn: () => getProfile(),
        retry: false,
    });

    const profile = data?.data || null;

    return { isLoading, error, profile, refetch };
}
